"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = exports.ErrorCode = exports.SortDirections = exports.Statuses = void 0;
var Statuses;
(function (Statuses) {
    Statuses["ACTIVE"] = "active";
    Statuses["INACTIVE"] = "inactive";
})(Statuses = exports.Statuses || (exports.Statuses = {}));
var SortDirections;
(function (SortDirections) {
    SortDirections["ASC"] = "asc";
    SortDirections["DESC"] = "desc";
})(SortDirections = exports.SortDirections || (exports.SortDirections = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["INVALID_URL"] = "INVALID_URL";
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ErrorCode["ITEM_MISMATCH"] = "ITEM_MISMATCH";
    ErrorCode["UPDATE_FAILED"] = "UPDATE_FAILED";
    ErrorCode["ACCESS_DENIED"] = "ACCESS_DENIED";
    ErrorCode["FILE_NOT_FOUND"] = "FILE_NOT_FOUND";
    ErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ErrorCode["INVALID_REQUEST"] = "INVALID_REQUEST";
    ErrorCode["EXPIRED_PROFILE"] = "EXPIRED_PROFILE";
    ErrorCode["INVALID_PROFILE"] = "INVALID_PROFILE";
    ErrorCode["INVALID_BATCH_ID"] = "INVALID_BATCH_ID";
    ErrorCode["INACTIVE_ACCOUNT"] = "INACTIVE_ACCOUNT";
    ErrorCode["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    ErrorCode["INVALID_SHORT_ID"] = "INVALID_SHORT_ID";
    ErrorCode["RECORD_NOT_FOUND"] = "RECORD_NOT_FOUND";
    ErrorCode["INACTIVE_PROFILE"] = "INACTIVE_PROFILE";
    ErrorCode["INVALID_CART_ITEM"] = "INVALID_CART_ITEM";
    ErrorCode["UNKNOWN_FILE_TYPE"] = "UNKNOWN_FILE_TYPE";
    ErrorCode["FILE_NOT_READABLE"] = "FILE_NOT_READABLE";
    ErrorCode["PROFILE_NOT_FOUND"] = "PROFILE_NOT_FOUND";
    ErrorCode["INVALID_PARAMETER"] = "INVALID_PARAMETER";
    ErrorCode["MISSING_PRODUCT_ID"] = "MISSING_PRODUCT_ID";
    ErrorCode["MISSING_OUTPUT_FILE"] = "MISSING_OUTPUT_FILE";
    ErrorCode["INVALID_COUPON_CODE"] = "INVALID_COUPON_CODE";
    ErrorCode["CURRENCY_IS_REQUIRED"] = "CURRENCY_IS_REQUIRED";
    ErrorCode["QR_CODE_STILL_ACTIVE"] = "QR_CODE_STILL_ACTIVE";
    ErrorCode["MAXIMUM_SCANS_REACHED"] = "MAXIMUM_SCANS_REACHED";
    ErrorCode["ERROR_SAVING_ZIP_FILE"] = "ERROR_SAVING_ZIP_FILE";
    ErrorCode["VERIFICATION_REQUIRED"] = "VERIFICATION_REQUIRED";
    ErrorCode["INVALID_ACTIVATION_CODE"] = "INVALID_ACTIVATION_CODE";
    ErrorCode["BATCH_DETAILS_NOT_FOUND"] = "BATCH_DETAILS_NOT_FOUND";
    ErrorCode["CART_SESSION_STILL_FRESH"] = "CART_SESSION_STILL_FRESH";
    ErrorCode["TEXT_COULD_NOT_BE_COPIED"] = "TEXT_COULD_NOT_BE_COPIED";
    ErrorCode["ERROR_GENERATING_ZIP_FILE"] = "ERROR_GENERATING_ZIP_FILE";
    ErrorCode["AT_LEAST_ONE_FILE_REQUIRED"] = "AT_LEAST_ONE_FILE_REQUIRED";
    ErrorCode["ERROR_GENERATING_THUMBNAIL"] = "ERROR_GENERATING_THUMBNAIL";
    ErrorCode["MAXIMUM_IMAGE_COUNT_REACHED"] = "MAXIMUM_IMAGE_COUNT_REACHED";
    ErrorCode["MISSING_ORGANIZATION_DETAILS"] = "MISSING_ORGANIZATION_DETAILS";
    ErrorCode["GOOGLE_AUTHENTICATION_FAILED"] = "GOOGLE_AUTHENTICATION_FAILED";
    ErrorCode["MOBILE_NUMBER_FORMAT_IS_INVALID"] = "MOBILE_NUMBER_FORMAT_IS_INVALID";
    ErrorCode["SERVICE_NOT_AVAILABLE_AT_THE_MOMENT"] = "SERVICE_NOT_AVAILABLE_AT_THE_MOMENT";
    ErrorCode["MULTI_CURRENCY_CHECKOUT_NOT_SUPPORTED"] = "MULTI_CURRENCY_CHECKOUT_NOT_SUPPORTED";
    ErrorCode["SOMETHING_WENT_WRONG_WHILE_PROCESSING_REQUEST"] = "SOMETHING_WENT_WRONG_WHILE_PROCESSING_REQUEST";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
exports.ErrorMessage = {
    INVALID_URL: "URL is invalid!",
    ITEM_MISMATCH: "Item mismatch!",
    UPDATE_FAILED: "Update failed!",
    ACCESS_DENIED: "Access denied!",
    UNKNOWN_ERROR: "Unknown error!",
    INVALID_REQUEST: "Invalid request",
    INVALID_PROFILE: "Invalid profile",
    INVALID_SHORT_ID: "Invalid short id",
    INVALID_BATCH_ID: "Invalid batch id!",
    EXPIRED_PROFILE: "Profile is expired!",
    INVALID_PARAMETER: "Invalid parameter!",
    INVALID_CART_ITEM: "Invalid cart item!",
    UNKNOWN_FILE_TYPE: "Unknown file type!",
    MISSING_PRODUCT_ID: "Missing product id!",
    FILE_NOT_READABLE: "File is not readable!",
    FILE_NOT_FOUND: "Requested file not found!",
    MISSING_OUTPUT_FILE: "Missing output file!",
    INVALID_COUPON_CODE: "Invalid coupon code!",
    CURRENCY_IS_REQUIRED: "Currency is required!",
    INACTIVE_PROFILE: "Requested page is inactive!",
    MAXIMUM_SCANS_REACHED: "Maximum scans reached!",
    ERROR_SAVING_ZIP_FILE: "Error saving zip file!",
    QR_CODE_STILL_ACTIVE: "QR code is still active!",
    INVALID_ACTIVATION_CODE: "Invalid activation code!",
    BATCH_DETAILS_NOT_FOUND: "Batch details not found!",
    RECORD_NOT_FOUND: "Requested record was not found!",
    PROFILE_NOT_FOUND: "Requested profile was not found!",
    TEXT_COULD_NOT_BE_COPIED: "Text could not be copied!",
    ERROR_GENERATING_ZIP_FILE: "Error generating zip file!",
    ERROR_GENERATING_THUMBNAIL: "Error generating thumbnail!",
    GOOGLE_AUTHENTICATION_FAILED: "Google authentication failed",
    AT_LEAST_ONE_FILE_REQUIRED: "At lease one file is required!",
    MISSING_ORGANIZATION_DETAILS: "Missing organization details!",
    MAXIMUM_IMAGE_COUNT_REACHED: "Maximum images allowed has reached!",
    MOBILE_NUMBER_FORMAT_IS_INVALID: "Mobile number format is invalid!",
    CART_SESSION_STILL_FRESH: "Checkout session might still be in use!",
    UNAUTHORIZED: "You are unauthorised to access the requested resource!",
    MULTI_CURRENCY_CHECKOUT_NOT_SUPPORTED: "Multi currency checkout is not supported!",
    INACTIVE_ACCOUNT: "Account is inactive or has been disabled, please contact support!",
    USER_NOT_FOUND: "No matching record for the provided credentials, please sign up instead!",
    INVALID_PASSWORD: "The password provided was invalid, please retry with a different password.",
    SOMETHING_WENT_WRONG_WHILE_PROCESSING_REQUEST: "Something went wrong while processing your request",
    SERVICE_NOT_AVAILABLE_AT_THE_MOMENT: "Service is not available at the moment, please retry after some time",
    VERIFICATION_REQUIRED: "Account email verification is pending, please check your registered email address for verification instructions.",
};
